module.exports = __webpack_public_path__ + "assets/scroll-arrow.327ba1f7.svg";